import React from 'react'
import './style.scss'

export const Select = ({items, ...props}) => {
    return(
        <select className="ldsrf-select" {...props}>
            {items && items.map((item) => (
                <option disabled={item.disabled ? true:false} selected={item.selected ? true:false} value={item.value} {...item}>{item.title}</option>
            ))}
        </select>
    )
}